import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Router from "./router/Router";
import { IRootState } from ".";

import Profile from "./utils/apiServices/profile";
import { login, logout } from "./features/login/reducer";
import RootLoading from "./components/RootLoading/RootLoading";
import { generateToken, zim } from "./utils/chat";
import { setChat } from "./features/chat/reducer";
import { initializeLanguage } from "./features/language/languageSlice";

function App() {
  const dispatch = useDispatch();
  const [rootLoading, setRootLoading] = useState(true);
  const user = useSelector((state: IRootState) => state.user.value);
  const { loggedIn } = user;
  // access token
  const events = [
    "load",
    "mousemove",
    "mousedown",
    "click",
    "scroll",
    "keypress",
  ];

  let timer: any;

  const handleLogoutTimer = () => {
    timer = setTimeout(() => {
      // clears any pending timer.
      resetTimer();
      // Listener clean up. Removes the existing event listener from the window
      Object.values(events).forEach((item) => {
        window.removeEventListener(item, resetTimer);
      });
      // logs out user
      dispatch(logout());
    }, 6000000); // 10000ms = 10secs. You can change the time.
  };

  // this resets the timer if it exists.
  const resetTimer = () => {
    if (timer) clearTimeout(timer);
  };

  // Initialize language system
  useEffect(() => {
    dispatch(initializeLanguage());
  }, [dispatch]);

  useEffect(() => {
    Object.values(events).forEach((item) => {
      window.addEventListener(item, () => {
        resetTimer();
        handleLogoutTimer();
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const accessToken =
    localStorage.getItem("accessToken") ||
    sessionStorage.getItem("accessToken") ||
    "";

  // Get Profile
  useEffect(() => {
    let cancelled = false;
    const stopLoading = () => {
      if (!cancelled) setRootLoading(false);
    };
    const timeout = window.setTimeout(stopLoading, 8000);

    if (accessToken && !loggedIn) {
      Profile.getProfile()
        .then((res) => {
          if (cancelled) return;
          if (res.success) {
            const { data } = res;

            const localToken = localStorage.getItem("accessToken");
            dispatch(
              login({
                created_at: data.created_at,
                id: data.id,
                first_name: data.first_name,
                last_name: data.last_name,
                phone: data.phone,
                total_commission_earning: data.total_commission_earning,
                digital_received: data.digital_received,
                manual_received: data.manual_received,
                delivery_charge: data.delivery_charge,
                email: data.email,
                image: data.image,
                remember_token: data.remember_token,
                role_id: data.role_id,
                zone_id: data.zone_id,
                updated_at: data.updated_at,
                loggedIn: true,
                remember_me: !!localToken,
                access_token: accessToken,
              })
            );
            try {
              const userId = "1";
              const userName = "Admin";
              zim
                .login({ userName, userID: userId }, generateToken(userId, 0))
                .then(function () {
                  dispatch(
                    setChat({
                      isLogged: true,
                      isLoading: false,
                    })
                  );
                })
                .catch(() => {
                  dispatch(setChat({ isLogged: false, isLoading: false }));
                });
            } catch {
              dispatch(setChat({ isLogged: false, isLoading: false }));
            }
          } else {
            dispatch(logout());
          }
        })
        .catch(() => {
          dispatch(logout());
        })
        .finally(() => {
          window.clearTimeout(timeout);
          stopLoading();
        });
    } else {
      window.clearTimeout(timeout);
      stopLoading();
    }

    return () => {
      cancelled = true;
      window.clearTimeout(timeout);
    };
    // eslint-disable-next-line
  }, []);
  return <div className="">{rootLoading ? <RootLoading /> : <Router />}</div>;
}

export default App;
